var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-select',{attrs:{"options":_vm.parcelas,"required":"","name":"Parcelas","label":"Prazo"},on:{"change":_vm.change},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }